module.exports = __webpack_public_path__ + "img/siguiente.008ce42d.png";